export enum LoseSceneResult {
    Continue = "Continue",
    Home = "Home",
    Restart = "Restart"
}
